import { SectionTranslationModel } from '@/assets/locales/views/employeeProfile/sections/SectionTranslation.model.ts';

export type EmployeeProfileOrganizationalAssignmentSectionTranslation = SectionTranslationModel<{
  left: {
    company: string;
    functionalArea: string;
    grade: string;
    organizationUnit: string;
    positionSeniority: string;
    region: string;
    workSeniority: string;
    zone: string;
  };
  right: {
    employmentHistory: string;
    notFound: string;
  };
}>;

export const employeeProfileOrganizationalAssignmentSectionTranslation: EmployeeProfileOrganizationalAssignmentSectionTranslation =
  {
    content: {
      left: {
        company: 'Firma',
        functionalArea: 'Obszar funkcjonalny',
        grade: 'Grade',
        organizationUnit: 'Jednostka organizacyjna',
        positionSeniority: 'Staż pracy na obecnym stanowisku',
        region: 'Region',
        workSeniority: 'Staż pracy w JMP',
        zone: 'Zona',
      },
      right: {
        employmentHistory: 'Historia zatrudnienia',
        notFound: 'Nie znaleziono historii zatrudnienia',
      },
    },
    headerTitle: 'Przypisania organizacyjne',
    headerTitleShorter: 'Przypisania organizacyjne',
  };
